const cartMiddleware = (store: any) => (next: any) => (action: any) => {
  if (action.type.startsWith("cart/addItem")) {
    const cartState = store.getState().cart;
    if (cartState.items.length > 0) {
      const { payload }: any = action;
      const typeOfElementsInCart = cartState.items.map(
        (item: any) => item.attributes?.is_private || false,
      );
      let newItemAccess = payload.data?.attributes?.is_private || false;

      if (!typeOfElementsInCart.includes(newItemAccess)) {
        return false;
      }
    }
  }

  return next(action);
};

export default cartMiddleware;
